<template>
  <BreadCrumb v-if="environment=='PROD'" :PageTitle="$t('breadCrumb.doubleentrylist')" />
  <BreadCrumb v-if="environment=='DEMO'" :PageTitle="$t('breadCrumb.doubleentrylist')" />
  <DoubleWrite/>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import stateStore from "../../utils/store";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DoubleWrite from "../../components/CRM/Leads/DoubleWriteContent.vue";


export default defineComponent({
  name: "DoubleWriteList",
  components: {
    BreadCrumb,
    DoubleWrite,
  },
  setup() {
    const { t } = useI18n();
    let environment = process.env.VUE_APP_TEST
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
      stateStoreInstance.show = true;
    });
    return { stateStoreInstance, environment, t };
  }
});
</script>